import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class SchoolVisitsDataTable {
  constructor() {
    $(document).ready(function() {
      showSchoolVisitsTable();
    });

    $(document).on("turbo:render", function() {
      showSchoolVisitsTable();
    });

    function showSchoolVisitsTable() {
      $('#school-visits-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#school-visits-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
